import { Link } from 'react-router-dom';
import { ShieldAlert } from 'lucide-react';

export function Forbidden() {
  return (
    <div className="min-h-screen bg-background text-foreground flex flex-col items-center justify-center gap-4 px-6 text-center">
      <ShieldAlert className="h-10 w-10 text-destructive" aria-hidden="true" />
      <h1 className="text-3xl font-bold tracking-tight">403 — Not authorised</h1>
      <p className="text-muted-foreground text-sm max-w-md">
        You don&apos;t have permission to view that page. If you think this is a mistake, contact a
        Raptor administrator.
      </p>
      <Link
        to="/dashboard"
        className="rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
      >
        Back to dashboard
      </Link>
    </div>
  );
}
